const $btn = $(".js-popup-btn");

var $calendar = document.getElementById("calendar-view");

const $body1 = $(".popup__body1");
const $body2 = $(".popup__body2");
const $calculate = $(".js-calculate");

$calculate.on("click", function (e) {
  e.preventDefault();

  if ($(".js-hidden-calendar2")) {
    $(".js-hidden-calendar2").append($calendar);
  }
  $body1.addClass("hide-content");
  $body2.removeClass("hide-content");
});

$(".js-redo-test").on("click", function (e) {
  e.preventDefault();

  $(".js-hidden-calendar").append($calendar);
  $body1.removeClass("hide-content");
  $body2.addClass("hide-content");
});
